import { TeachingHoursByTeacher, TeachingHoursStatisticsQuery } from '../../../shared/types/database';
import { getAuthToken } from '../utils/auth';

const API_BASE = '/api/v1/statistic';

export const statisticService = {
  // Thống kê giờ giảng theo giáo viên
  async getTeachingHoursByTeacher(query: TeachingHoursStatisticsQuery): Promise<TeachingHoursByTeacher[]> {
    const params = new URLSearchParams();
    
    // Thêm mode
    params.append('mode', query.mode);
    
    // Thêm các tham số theo mode
    if (query.mode === 'date') {
      if (query.fromDate) params.append('fromDate', query.fromDate);
      if (query.toDate) params.append('toDate', query.toDate);
    } else if (query.mode === 'month') {
      if (query.month) params.append('month', query.month.toString());
      if (query.year) params.append('year', query.year.toString());
    } else if (query.mode === 'quarter') {
      if (query.quarter) params.append('quarter', query.quarter.toString());
      if (query.year) params.append('year', query.year.toString());
    } else if (query.mode === 'year') {
      if (query.year) params.append('year', query.year.toString());
    }
    
    // Thêm teacherId - luôn cố gắng lấy từ localStorage hoặc query
    let teacherId = query.teacherId;
    if (!teacherId) {
      // Lấy từ localStorage với key mới
      const userInfo = JSON.parse(localStorage.getItem('quanly_truonghoc_user') || '{}');
      teacherId = userInfo.Username || userInfo.username;
      
      // Fallback: thử key cũ
      if (!teacherId) {
        const oldUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        teacherId = oldUserInfo.Username || oldUserInfo.username;
      }
    }
    
    if (teacherId) {
      params.append('teacherId', teacherId);
    }
    
    // Lấy token với key đúng
    const token = getAuthToken();
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    const response = await fetch(`${API_BASE}/teaching-hours-by-teacher?${params.toString()}`, {
      method: 'GET',
      headers
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lỗi khi lấy thống kê giờ giảng');
    }
    
    return await response.json();
  },

  // Export Excel cho thống kê giờ giảng
  async exportTeachingHoursToExcel(data: TeachingHoursByTeacher[]): Promise<void> {
    try {
      // Dynamic import XLSX
      const XLSX = await import('xlsx');
      
      const exportData = data.map((row, idx) => ({
        'STT': idx + 1,
        'Ngày giảng': row.NgayGiang ? new Date(row.NgayGiang).toLocaleDateString('vi-VN') : '',
        'Buổi giảng': row.BuoiGiang || '',
        'Tên bài giảng': row.TenBaiGiang || '',
        'Khóa học': row.TenKhoaHoc || '',
        'Môn học': row.TenMonHoc || '',
        'Lớp học phần': row.TenLopHP || '',
        'Số tiết LT': row.SoTietLT || 0,
        'Số tiết TH': row.SoTietTH || 0,
        'Sĩ số': row.SiSo || 0
      }));
      
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Thống kê giờ giảng');
      
      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const filename = `ThongKeGioGiang_${timestamp}.xlsx`;
      
      XLSX.writeFile(wb, filename);
    } catch (error) {
      console.error('Error exporting Excel:', error);
      throw new Error('Không thể xuất file Excel. Vui lòng thử lại.');
    }
  }
};
